//noinspection JSUnusedGlobalSymbols
export const environment = {
  production: true,
  canEdit: true,
  canSave: true,
  api: 'https://api.staging.k8s.process-manager.dk/api/',
  base: 'https://api.staging.k8s.process-manager.dk/',
  nonconformity: 'https://nc.staging.k8s.process-manager.dk/'
};
